import React from "react";
import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function HeroCallToAction() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="28914" id="solar-battery-generator-solutions" ref={ref} className="bg-primary relative overflow-hidden py-16 md:py-24 lg:py-32">
      <div className="container mx-auto px-4 md:px-6">
        <div className="grid gap-12 lg:grid-cols-2 lg:gap-16 items-center">
          {}
          <div className={`flex flex-col items-start space-y-8 transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
            <h1 className="text-primary-foreground font-sans text-4xl font-extrabold tracking-tighter sm:text-5xl md:text-6xl lg:leading-[1.1] uppercase">
              Reliable energy for the road with custom{" "}
              <span className="text-secondary drop-shadow-[0_0_15px_var(--color-secondary)]">
                SOLAR
              </span>{" "}
              systems
            </h1>
            
            <p className="text-primary-foreground/80 font-sans text-lg leading-relaxed md:text-xl max-w-[90%]">
              Maximize your caravan's potential with high-efficiency panels, lithium battery upgrades, 
              and silent generator installations. Expertly fitted in South Windsor to ensure you 
              never run out of power off-grid.
            </p>

            <div className="flex flex-col sm:flex-row gap-4 w-full sm:w-auto pt-2">
              <Button asChild size="lg" className="bg-accent text-accent-foreground hover:bg-accent/90 hover:scale-[1.02] transition-all duration-300 shadow-lg shadow-accent/20 text-base font-bold h-14 px-8 rounded-sm">
                <Link to="/StartYourQuotePage">
                  Start Your Quote
                  <ArrowRight className="ml-2 h-5 w-5" />
                </Link>
              </Button>
            </div>
            
            <p className="text-sm text-primary-foreground/60 italic font-mono uppercase tracking-wider">
              *Certified electrical installations for all caravan makes and models.
            </p>
          </div>

          {}
          <div className={`relative mx-auto w-full max-w-[600px] lg:max-w-none transition-all duration-1000 delay-200 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
            <div className="relative aspect-[4/3] w-full overflow-hidden rounded-xl shadow-2xl shadow-black/40 ring-1 ring-white/10">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1599594/img/solar_panels_caravan_roof.png" alt="High-tech solar panel installation on a caravan roof" className="h-full w-full object-cover object-center transition-transform duration-700 hover:scale-105" loading="eager" />
              
              {}
              <div className="absolute inset-0 bg-gradient-to-tr from-primary/40 to-transparent pointer-events-none backdrop-brightness-90" />
            </div>

            {}
            <div className="absolute -bottom-6 -left-6 hidden md:flex items-center gap-3 bg-card p-4 rounded-md shadow-xl border border-border/50 animate-in fade-in slide-in-from-bottom-4 duration-1000 delay-500 fill-mode-forwards opacity-0" style={{
            animationDelay: '800ms'
          }}>
              <div className="flex -space-x-3">
                {[1, 2, 3].map(i => <div key={i} className="h-10 w-10 rounded-full border-2 border-card bg-muted overflow-hidden">
                     <img src={`/img/avatar_user_${i}.png`} alt="Satisfied Customer" className="h-full w-full object-cover" />
                  </div>)}
              </div>
              <div className="flex flex-col">
                <span className="text-sm font-bold text-foreground font-sans">500+ Installs</span>
                <span className="text-xs text-muted-foreground font-mono">5-Star Rated</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}